import ContinueButton from "components/selection-components/customize-wizard/continue-button";
import { usePreorderValidationNavigation } from "components/selection-components/preorder/use-preorder-validation-navigation";
import { PreorderContext } from "context/preorder-context";
import { t } from "i18next";
import { useContext } from "react";

interface IPreorderContinueButton {
    key?: string;
    onContinue: () => Promise<void>;
    trackingId?: string;
    /**
     * Blocks the button while the menu is still loading. Until it arrives there is nothing to
     * validate against, so a click would pass straight through a mandatory menu.
     */
    isDisabled?: boolean;
}

const PreorderContinueButton = ({
    onContinue,
    trackingId,
    isDisabled,
}: IPreorderContinueButton) => {
    const { currentTotalQuantity, isPreorderValid, nextInvalidGroup } =
        useContext(PreorderContext) || {};
    const navigateToInvalidGroup = usePreorderValidationNavigation();

    const validPreorderButtonText =
        currentTotalQuantity === 0
            ? t("preorder.continueWithoutItems")
            : t("preorder.continueWithItemsPrefix", {
                  totalQuantity: currentTotalQuantity,
                  suffix:
                      currentTotalQuantity === 1
                          ? t("preorder.continueWithItemsSingularSuffix")
                          : t("preorder.continueWithItemsPluralisSuffix"),
              });

    const helperButtonText = t("preorder.continueWithGroupHelperText", {
        menuGroup: nextInvalidGroup?.name || "",
    });

    const handleClick = async () => {
        if (isPreorderValid) {
            await onContinue();
        } else {
            navigateToInvalidGroup();
        }
    };

    return (
        <ContinueButton
            buttonText={isPreorderValid ? validPreorderButtonText : helperButtonText}
            onContinue={handleClick}
            trackingId={trackingId}
            isDisabled={isDisabled}
        />
    );
};

export default PreorderContinueButton;
